const routeNames = require('./routeNames');

const GUID_PATTERN = '([a-f\\d]{8}-[a-f\\d]{4}-[4|7][a-f\\d]{3}-[89ab][a-f\\d]{3}-[a-f\\d]{12})';

// the tokenId must be a valid guid https://gist.github.com/bugventure/f71337e3927c34132b9a
const tokenId = `:tokenId${GUID_PATTERN}`;

/**
 * Define all routes below.
 *
 * Each route must include the following:
 * {
 *   name: '',
 *   pattern: '',
 *   page: '/index',
 *   type: supplier or admin
 * }
 */
const routes = [
  // Unauthenticated Routes
  {
    name: 'SignIn',
    pattern: '/sign-in',
    page: 'admin/SignIn',
    type: 'admin'
  },
  {
    name: 'ForgotPassword',
    pattern: '/forgot-password',
    page: 'admin/ForgotPassword',
    type: 'admin'
  },
  {
    name: 'ResetPassword',
    pattern: '/reset-password',
    page: 'admin/ResetPassword',
    type: 'admin'
  },
  {
    name: 'ConfirmBooking',
    pattern: `/confirm-booking/${tokenId}`,
    page: 'admin/Token/ConfirmBooking',
    type: 'admin'
  },
  {
    name: 'RejectBooking',
    pattern: `/reject-booking/${tokenId}`,
    page: 'admin/Token/RejectBooking',
    type: 'admin'
  },
  {
    name: 'Token',
    pattern: `/t/${tokenId}`,
    page: 'admin/Token',
    type: 'admin'
  },

  // Normal Routes
  {
    name: 'Home',
    pattern: '',
    page: 'admin/Dashboard',
    type: 'admin'
  },
  {
    name: 'Dashboard',
    pattern: '',
    page: 'admin/Dashboard',
    type: 'admin'
  },
  {
    name: 'AccountSettings',
    pattern: '/account-settings',
    page: 'admin/AccountSettings',
    type: 'admin'
  },

  // Bookings
  {
    name: 'Bookings',
    pattern: '/bookings',
    page: 'admin/Bookings',
    type: 'admin'
  },
  {
    name: 'BookingOverview',
    pattern: '/booking/:bookingId',
    page: 'admin/Bookings/Booking',
    type: 'admin'
  },
  {
    name: 'BookingRoomNights',
    pattern: '/booking/:bookingId/room-nights',
    page: 'admin/Bookings/Booking/RoomNights',
    type: 'admin'
  },
  {
    name: 'BookingFolios',
    pattern: '/booking/:bookingId/folios',
    page: 'admin/Bookings/Booking/Folios',
    type: 'admin'
  },
  {
    name: 'BookingPaymentRecords',
    pattern: '/booking/:bookingId/payment-records',
    page: 'admin/Bookings/Booking/PaymentRecords',
    type: 'admin'
  },
  {
    name: 'BookingVirtualCreditCard',
    pattern: '/booking/:bookingId/vcc',
    page: 'admin/Bookings/Booking/VCC',
    type: 'admin'
  },
  {
    name: 'BookingTickets',
    pattern: '/booking/:bookingId/tickets',
    page: 'admin/Bookings/Booking/Tickets',
    type: 'admin'
  },
  {
    name: 'BookingRateCards',
    pattern: '/booking/:bookingId/rate-cards',
    page: 'admin/Bookings/Booking/RateCards',
    type: 'admin'
  },
  {
    name: 'BookingCreate',
    pattern: '/bookings/create',
    page: 'admin/Bookings/BookingCreate',
    type: 'admin'
  },

  // Customers
  {
    name: 'Customers',
    pattern: '/customers',
    page: 'admin/CustomerManagement',
    type: 'admin'
  },
  {
    name: 'CustomerOverview',
    pattern: '/customer/:customerId',
    page: 'admin/CustomerManagement/Customer',
    type: 'admin'
  },
  {
    name: 'CustomerMembers',
    pattern: '/customer/:customerId/members',
    page: 'admin/CustomerManagement/Customer/Members',
    type: 'admin'
  },
  {
    name: 'MemberDetails',
    pattern: '/customer/:customerId/member/:identityId',
    page: 'admin/CustomerManagement/Customer/MemberDetails',
    type: 'admin'
  },
  {
    name: 'CustomerRates',
    pattern: '/customer/:customerId/rates',
    page: 'admin/CustomerManagement/Customer/Rates',
    type: 'admin'
  },
  {
    name: 'CustomerPreferences',
    pattern: '/customer/:customerId/preferences',
    page: 'admin/CustomerManagement/Customer/Preferences',
    type: 'admin'
  },
  {
    name: 'CustomerFeatureSettings',
    pattern: '/customer/:customerId/feature-settings',
    page: 'admin/CustomerManagement/Customer/FeatureSettings',
    type: 'admin'
  },
  {
    name: 'CustomerPaymentIds',
    pattern: '/customer/:customerId/payment-ids',
    page: 'admin/CustomerManagement/Customer/PaymentIds',
    type: 'admin'
  },
  {
    name: 'CustomerTrackingCodes',
    pattern: '/customer/:customerId/tracking-codes',
    page: 'admin/CustomerManagement/Customer/TrackingCodes',
    type: 'admin'
  },
  // Pending Requests
  {
    name: 'PendingRequests',
    pattern: '/customers/pending-requests',
    page: 'admin/PendingRequests',
    type: 'admin'
  },
  {
    name: 'OrgRequests',
    pattern: '/customers/pending-requests#tab-0',
    page: 'admin/PendingRequests',
    type: 'admin'
  },
  {
    name: 'UserRequests',
    pattern: '/customers/pending-requests#tab-1',
    page: 'admin/PendingRequests',
    type: 'admin'
  },
  {
    name: 'PendingCreditRequests',
    pattern: '/customers/pending-requests#tab-2',
    page: 'admin/PendingRequests',
    type: 'admin'
  },
  // Feature Flags
  {
    name: 'FeatureFlags',
    pattern: '/customers/feature-flags',
    page: 'admin/FeatureFlags',
    type: 'admin'
  },
  {
    name: 'FeatureFlagOverview',
    pattern: '/customers/feature-flag/:id',
    page: 'admin/FeatureFlags/FeatureFlagOverview',
    type: 'admin'
  },

  // Suppliers
  {
    name: 'Suppliers',
    pattern: '/suppliers',
    page: 'admin/SupplierManagement',
    type: 'admin'
  },
  {
    name: 'SupplierOverview',
    pattern: '/supplier/:supplierId',
    page: 'admin/SupplierManagement/Suppliers',
    type: 'admin'
  },
  {
    name: 'SupplierProperties',
    pattern: '/supplier/:supplierId/properties',
    page: 'admin/SupplierManagement/Suppliers/Properties',
    type: 'admin'
  },
  {
    name: routeNames.SUPPLIER_PROPERTY_OVERVIEW,
    pattern: '/supplier/:supplierId/property/:propertyId',
    page: 'admin/SupplierManagement/Suppliers/PropertyOverview',
    type: 'admin'
  },
  {
    name: routeNames.SUPPLIER_PROPERTY_ROOMS,
    pattern: '/supplier/:supplierId/property/:propertyId/rooms',
    page: 'admin/SupplierManagement/Suppliers/PropertyRooms',
    type: 'admin'
  },
  {
    name: routeNames.SUPPLIER_PROPERTY_CONNECTION,
    pattern: '/supplier/:supplierId/property/:propertyId/connection',
    page: 'admin/SupplierManagement/Suppliers/PropertyConnection',
    type: 'admin'
  },
  {
    name: routeNames.SUPPLIER_PROPERTY_RATE_MARKUP_LOGS,
    pattern: '/supplier/:supplierId/property/:propertyId/rate-markup-logs',
    page: 'admin/SupplierManagement/Suppliers/PropertyRateMarkupLogs',
    type: 'admin'
  },
  {
    name: routeNames.SUPPLIER_PROPERTY_ADD_ROOMS,
    pattern: '/supplier/:supplierId/property/:propertyId/add-rooms',
    page: 'admin/SupplierManagement/Suppliers/Properties/AddRooms',
    type: 'supplier'
  },
  {
    name: routeNames.Margins,
    pattern: '/margins',
    page: 'admin/Margins',
    type: 'admin'
  },
  {
    name: 'RateCards',
    pattern: '/suppliers/rate-cards',
    page: 'admin/RateCards',
    type: 'admin'
  },
  {
    name: 'RateCardsSelected',
    pattern: '/suppliers/rate-cards/:propertyId',
    page: 'admin/RateCards',
    type: 'admin'
  },
  {
    name: 'ConnectionManagement',
    pattern: '/suppliers/connection-management',
    page: 'admin/ConnectionManagement',
    type: 'admin'
  },
  {
    name: 'RateEngineManagement',
    pattern: '/suppliers/rate-engine-management',
    page: 'admin/RateEngineManagement',
    type: 'admin'
  },

  // Users
  {
    name: 'Users',
    pattern: '/users',
    page: 'admin/UserManagement',
    type: 'admin'
  },
  {
    name: 'UserOverview',
    pattern: '/user/:id',
    page: 'admin/UserManagement/UserDetails',
    type: 'admin'
  },
  {
    name: 'Roles',
    pattern: '/users/roles',
    page: 'admin/RoleManagement',
    type: 'admin'
  },

  // Permissions
  {
    name: 'Permissions',
    pattern: '/users/permissions',
    page: 'admin/RoleManagement/ViewPermissionsPage',
    type: 'admin'
  },
  {
    name: 'CreatePermission',
    pattern: '/users/permissions/create',
    page: 'admin/RoleManagement/ViewPermissionsPage/CreatePermissionPage',
    type: 'admin'
  },

  // COGS
  {
    name: 'COGS',
    pattern: '/accounting/cogs',
    page: 'admin/Folios',
    type: 'admin'
  },
  {
    name: 'FoliosByBooking',
    pattern: '/accounting/cogs/folios-by-booking',
    page: 'admin/Folios/FoliosByBooking',
    type: 'admin'
  },
  {
    name: 'FolioMissing',
    pattern: '/accounting/cogs/missing-folios',
    page: 'admin/Folios/FolioMissing',
    type: 'admin'
  },
  {
    name: 'FolioOverview',
    pattern: '/accounting/cogs/:folioId',
    page: 'admin/Folios/FolioDetails',
    type: 'admin'
  },

  // Reconciliation
  {
    name: 'Reconciliation',
    pattern: '/accounting/reconciliation',
    page: 'admin/Reconciliation',
    type: 'admin'
  },
  {
    name: 'Viewer',
    pattern: '/accounting/reconciliation/folios/:bookingId',
    page: 'admin/Folios/Viewer',
    type: 'admin'
  },

  // Chargesheets
  {
    name: routeNames.CHARGESHEETS,
    pattern: '/accounting/chargesheets',
    page: 'admin/Chargesheets',
    type: 'admin'
  },
  {
    name: routeNames.CreateChargesheet,
    pattern: '/accounting/chargesheet/create',
    page: 'admin/Chargesheets/ChargesheetCreate',
    type: 'admin'
  },
  {
    name: routeNames.CreateChargesheets,
    pattern: '/accounting/chargesheets/create',
    page: 'admin/Chargesheets/ChargesheetsCreate',
    type: 'admin'
  },
  {
    name: routeNames.CHARGESHEET,
    pattern: '/accounting/chargesheet/:id',
    page: 'admin/Chargesheets/ChargesheetOverview',
    type: 'admin'
  },
  {
    name: 'ChargesheetPreview',
    pattern: '/accounting/chargesheet/:id/preview',
    page: 'admin/Chargesheets/ChargesheetPreviewPage',
    type: 'admin'
  },
  {
    name: 'ChargesheetFolios',
    pattern: '/accounting/chargesheet/:id/folios',
    page: 'admin/Chargesheets/ChargesheetFolios',
    type: 'admin'
  },
  // Invoices
  {
    name: 'Invoices',
    pattern: '/accounting/invoices',
    page: 'admin/Invoices/Invoices',
    type: 'admin'
  },
  // A draft invoice is a grouping key rather than a saved row, so it gets its own pattern;
  // both resolve to the same details page, which branches on whichever param it receives.
  {
    name: 'DraftInvoiceDetails',
    pattern: '/accounting/invoice/draft/:invoiceKey',
    page: 'admin/Invoices/InvoiceDetails',
    type: 'admin'
  },
  {
    name: 'InvoiceDetails',
    pattern: '/accounting/invoice/:invoiceId',
    page: 'admin/Invoices/InvoiceDetails',
    type: 'admin'
  },

  // Vendor Bills
  {
    name: 'VendorBills',
    pattern: '/accounting/vendorbills',
    page: 'admin/VendorBills/VendorBills',
    type: 'admin'
  },
  {
    name: 'DraftVendorBillDetails',
    pattern: '/accounting/vendorbills/draft/:billKey',
    page: 'admin/VendorBills/VendorBillDetails',
    type: 'admin'
  },
  {
    name: 'VendorBillDetails',
    pattern: '/accounting/vendorbills/:billId',
    page: 'admin/VendorBills/VendorBillDetails',
    type: 'admin'
  },

  // Taxes and Fees
  {
    name: 'TaxTemplates',
    pattern: '/accounting/tax-templates',
    page: 'admin/TaxesAndFees/TaxTemplates',
    type: 'admin'
  },
  {
    name: 'TaxesAndFees',
    pattern: '/accounting/taxes-fees',
    page: 'admin/TaxesAndFees/TaxesFees',
    type: 'admin'
  },

  // Tickets
  {
    name: 'Tickets',
    pattern: '/tickets',
    page: 'admin/Tickets',
    type: 'admin'
  },
  {
    name: 'TicketOverview',
    pattern: '/ticket/:id',
    page: 'admin/Tickets/TicketDetails',
    type: 'admin'
  },

  // Accounts
  {
    name: 'AccountManagement',
    pattern: '/vccs/account-management',
    page: 'admin/AccountManagement',
    type: 'admin'
  },

  // Card Management
  {
    name: 'CardManagement',
    pattern: '/vccs/card-management',
    page: 'admin/CardManagement',
    type: 'admin'
  },

  // Approvals
  {
    name: 'Approvals',
    pattern: '/vccs/approvals/virtualcreditcard',
    page: 'admin/Approvals',
    type: 'admin'
  },
  {
    name: 'ApprovalSingle',
    pattern: '/vccs/approvals/:approvalType/:approvalId?',
    page: 'admin/Approvals',
    type: 'admin'
  },
  {
    name: 'CustomerOverviewEmail',
    pattern: '/customer-management/customer/:customerId',
    page: 'admin/CustomerManagement/Customers/Customer',
    type: 'admin'
  },
  {
    name: 'PaymentOptionsEmail',
    pattern: '/customer-management/customer/:customerId#tab-2',
    page: 'admin/CustomerManagement/Customers/Customer/PaymentOption',
    type: 'admin'
  },
  {
    name: 'PendingRequestsEmail',
    pattern: '/pending-requests',
    page: 'admin/PendingRequests',
    type: 'admin'
  }
];

module.exports = routes;
